import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Route, Switch, BrowserRouter } from "react-router-dom";
import ConstituentTile from "./routes/constituent-tile/constituenttile"
import BatchTile from './routes/batch-tile/batchtile'
import 'simplebar/dist/simplebar.min.css';

ReactDOM.render(
  <BrowserRouter>
    <Switch>
      <Route path="/constituenttile" component={ConstituentTile} />
      <Route path="/batchtile" component={BatchTile} />
      <Route path="/" component={App} />
    </Switch>
  </BrowserRouter>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
